import { makeAutoObservable } from "mobx";

class AssignmentStore {
  /** @type {Map<string, object>} disclosureId → assignment object */
  assignmentsByDisclosureId = new Map();
  companyUsers = [];
  loading = false;
  showAssignDialog = false;
  filterAssignedToMe = false;

  constructor() {
    makeAutoObservable(this);
  }

  setAssignments = (assignments) => {
    this.assignmentsByDisclosureId.clear();
    for (const a of assignments) {
      const discId =
        typeof a.disclosureId === "object"
          ? a.disclosureId?._id
          : a.disclosureId;
      this.assignmentsByDisclosureId.set(discId, a);
    }
  };

  setAssignment = (disclosureId, assignment) => {
    this.assignmentsByDisclosureId.set(disclosureId, assignment);
  };

  removeAssignmentByDisclosureId = (disclosureId) => {
    this.assignmentsByDisclosureId.delete(disclosureId);
  };

  getAssignment = (disclosureId) => {
    return this.assignmentsByDisclosureId.get(disclosureId) || null;
  };

  setCompanyUsers = (users) => {
    this.companyUsers = users;
  };

  setLoading = (loading) => {
    this.loading = loading;
  };

  setShowAssignDialog = (show) => {
    this.showAssignDialog = show;
  };

  setFilterAssignedToMe = (value) => {
    this.filterAssignedToMe = value;
  };

  reset = () => {
    this.assignmentsByDisclosureId.clear();
    this.companyUsers = [];
    this.loading = false;
    this.showAssignDialog = false;
    this.filterAssignedToMe = false;
  };
}

export const assignmentStore = new AssignmentStore();
